import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import {
  WarningFilled,
  InfoCircleFilled,
} from '@ant-design/icons';

import { formatHours } from './redistributionHelpers';
import Colors from '../../../../../constants/Colors';
import OnTraccrButton from '../../../../../common/buttons/OnTraccrButton';

export default function RedistributeReviewModal({
  visible,
  remainingRows,
  overrunRows,
  onReturn,
  onProceed,
}) {
  const hasRemaining = remainingRows.length > 0;
  const hasOverrun = overrunRows.length > 0;

  return (
    <Modal
      visible={visible}
      onCancel={onReturn}
      footer={null}
      centered
      width={480}
      className="ttg-redistribute-review-modal-wrap"
      destroyOnClose
    >
      <div className="ttg-redistribute-review-sheet">
        <div className="ttg-redistribute-review-header">
          <WarningFilled style={{ fontSize: 16, color: Colors.RED_600 }} />
          <span className="ttg-redistribute-review-title">Review before submitting</span>
        </div>

        {hasRemaining && (
          <>
            <p className="ttg-redistribute-review-body">
              {remainingRows.length}
              {' '}
              crew members still have unassigned hours:
            </p>
            <div className="ttg-redistribute-review-list">
              {remainingRows.map((row) => (
                <div
                  key={`remaining-${row.id}`}
                  className="ttg-redistribute-review-list-item"
                >
                  <InfoCircleFilled style={{ fontSize: 15, color: '#F97316' }} />
                  <span className="ttg-redistribute-review-list-item-name">
                    {row.name}
                  </span>
                  <span className="ttg-redistribute-review-list-item-value">
                    {formatHours(row.unassignedTotal)}
                    &nbsp;unassigned
                  </span>
                </div>
              ))}
            </div>
          </>
        )}

        {hasOverrun && (
          <div className="ttg-redistribute-review-list-overrun">
            {overrunRows.map((row) => (
              <div
                key={`overrun-${row.id}`}
                className="ttg-redistribute-review-list-item ttg-redistribute-review-list-item-overrun"
              >
                <WarningFilled style={{ fontSize: 15, color: Colors.RED_600 }} />
                <span className="ttg-redistribute-review-list-item-name">
                  {row.name}
                </span>
                <span className="ttg-redistribute-review-list-item-value ttg-redistribute-review-list-item-value-overrun">
                  +
                  {formatHours(row.overrunBy)}
                  &nbsp;over
                </span>
              </div>
            ))}
            <p className="ttg-redistribute-review-list-overrun-footer-text">
              This adds cost beyond what was originally reported.
            </p>
          </div>
        )}

        <div className="ttg-redistribute-review-actions">
          <OnTraccrButton
            title="Return to corrections"
            type="cancel"
            className="ttg-redistribute-review-secondary"
            onClick={onReturn}
          />
          <OnTraccrButton
            title="Proceed anyway"
            type="primary"
            className="ttg-redistribute-review-primary"
            onClick={onProceed}
          />
        </div>
      </div>
    </Modal>
  );
}

const rowShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  unassignedTotal: PropTypes.number,
  overrunBy: PropTypes.number,
});

RedistributeReviewModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  remainingRows: PropTypes.arrayOf(rowShape),
  overrunRows: PropTypes.arrayOf(rowShape),
  onReturn: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
};

RedistributeReviewModal.defaultProps = {
  remainingRows: [],
  overrunRows: [],
};
